import {
	ROUTE_GROUPS_COMPONENTS,
	ROUTE_NAMES_ROVO_DEMAND_TESTS,
} from '@atlassian/jira-common-constants/src/spa-routes';

export const rovoDemandTestsRoute = {
	group: ROUTE_GROUPS_COMPONENTS,
	name: ROUTE_NAMES_ROVO_DEMAND_TESTS,
	path: '/jira/:projectType(software|software/c)/projects/:projectKey/rovo',
};
